export const Footer = () => (
  <footer data-testid="footer" className="border-t border-[#E5E3DA] bg-[#0B0C0E] text-white mt-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-[#FACC15] flex items-center justify-center font-black text-[#0B0C0E] text-lg">14</div>
          <span className="font-display font-black text-white text-xl uppercase tracking-tight">14 Acres</span>
        </div>
        <p className="text-slate-300 text-sm max-w-md leading-relaxed">
          Premium commercial / industrial storage and parking lots, available for monthly lease.
          Fully fenced. 24/7 secure access. Edmonton's NW corridor.
        </p>
      </div>
      <div>
        <div className="text-[11px] tracking-[0.22em] uppercase text-[#FACC15] font-semibold mb-4">Visit</div>
        <p className="text-sm text-slate-300 leading-relaxed">
          18961 118A Ave NW<br/>
          Edmonton, Alberta<br/>
          Canada
        </p>
      </div>
      <div>
        <div className="text-[11px] tracking-[0.22em] uppercase text-[#FACC15] font-semibold mb-4">Contact</div>
        <p className="text-sm text-slate-300 leading-relaxed">
          <a href="mailto:lease@14acre.ca" className="hover:text-[#FACC15]">lease@14acre.ca</a><br/>
          <a href="tel:+17800000000" className="hover:text-[#FACC15]">+1 (780) 000-0000</a><br/>
          14acre.ca
        </p>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500 tracking-wide">
      © {new Date().getFullYear()} 14 Acres Holdings. All rights reserved.
    </div>
  </footer>
);

export default Footer;
